import React, { Fragment, useState } from 'react';

import InactiveAccountLock from '@views/InactiveAccountLock';
import UnusualAccessLock from '@views/UnusualAccessLock';
import { useInsightsService } from '@lib/insightsService';

import { StepOne, StepTwo } from './Steps';

const Login = () => {
  const { authenticationEvent, reportInsight } = useInsightsService();
  const [step, setStep] = useState('email');
  const [email, setEmail] = useState('');
  const [lastSessionDate, setLastSessionDate] = useState(false);
  const [hasUnusualAccess, setHasUnusualAccess] = useState(false);
  const [hasInactiveAccount, setHasInactiveAccount] = useState(false);
  const [antiphishingData, setAntiphishingData] = useState({});

  const handleStepOneSuccess = (userEmail, antiphishingResponse) => {
    setStep('password');
    setEmail(userEmail);
    setAntiphishingData(antiphishingResponse);
  };

  const handleSuccessfulLogin = () => {
    reportInsight(authenticationEvent.successful);
  };

  const handleInactiveSession = lastSessionDateParam => {
    setHasInactiveAccount(true);
    setLastSessionDate(lastSessionDateParam);
  };

  if (hasUnusualAccess) {
    return (<UnusualAccessLock email={email} />);
  }

  if (hasInactiveAccount) {
    return (<InactiveAccountLock email={email} lastSessionDate={lastSessionDate} />);
  }

  return (
    <Fragment>
      {Boolean(step === 'email') && (
        <StepOne onSuccess={handleStepOneSuccess} />
      )}

      {Boolean(step === 'password') && (
        <StepTwo
          email={email}
          antiphishingData={antiphishingData}
          onCancel={() => setStep('email')}
          onSuccess={handleSuccessfulLogin}
          displayInactiveAccount={handleInactiveSession}
          displayUnusualAccess={() => setHasUnusualAccess(true)}
        />
      )}
    </Fragment>
  );
};

export default Login;
